<div class="position-absolute w-100">
    <div class="container">
        <div [@alertAnimations] *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
            <a class="close" (click)="removeAlert(alert)">&times;</a>
            <span [innerHTML]="alert.message"></span>
        </div>
    </div>
</div>
